<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="changePassword">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-key"></i> Alterar Senha
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-3" :class="{ 'has-danger': $v.model.senha.$error }">
                                    <dw-ipassword v-model="model.senha"
                                        @input="$v.model.senha.$touch()"
                                        ref="senha"
                                        placeholder="Senha"
                                        :length="6"
                                        :maxlength="30"
                                        class="mb-1"
                                        :class="{ 'has-danger': $v.model.senha.$error }"
                                        :helper="true"
                                        slot="input"></dw-ipassword>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-3" :class="{ 'has-danger': $v.model.repetirSenha.$error }">
                                    <dw-ipassword v-model="model.repetirSenha"
                                        @input="$v.model.repetirSenha.$touch()"
                                        ref="repetirSenha"
                                        placeholder="Repetir Senha"
                                        :length="6"
                                        :maxlength="30"
                                        class="mb-4"
                                        :class="{ 'has-danger': $v.model.repetirSenha.$error }"
                                        :helper="false"
                                        slot="input"></dw-ipassword>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'home' }" class="btn btn-link">Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {required, sameAs, minLength, maxLength} from 'vuelidate/lib/validators';
    import Facade from '../../facade/facade';
    const facade = new Facade();

    export default {
        data() {
            return {
                model: {
                    senha: '',
                    repetirSenha: ''
                }
            }
        },
        validations() {
            const vm = this
            return {
                model: {
                    senha: {
                        required,
                        minLength: minLength(6),
                        maxLength: maxLength(30),
                        isOk: (v) => {
                            return vm.$refs.senha.isValid()
                        }
                    },
                    repetirSenha: {
                        sameAsPassword: sameAs('senha')
                    }
                }
            };
        },
        methods: {
            changePassword() {
                let vm = this;
                if (this.$v.model.$invalid) {
                    this.$notify.warning('Atenção!', 'Verifique se todos os campos estão preenchidos corretamente.');
                    return;
                }

                this.$loading.show(true);
                let ret = facade.changePassword(this.model);
                ret.then(user => {
                    this.$notify.success('', 'Senha alterada com sucesso.');
                    vm.$router.push({name: 'home'});
                    vm.$loading.show(false);
                }).catch(e => {
                    e.forEach((item) => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ChangePassword.vue?41e26a75